<template>
  <b-overlay :show="showLoading">
    <b-row>
      <b-col cols="12">
        <b-card
            v-for="item in pageData"
            :key="item.staticPageId || item.title"
            :class="{ 'contact-item-inactive': item.content === '.' }"
        >

          <div class="d-flex align-items-center mb-2">
            <b-form-checkbox
                :checked="item.content !== '.'"
                switch
                @change="setActive(item, $event)"
            >
              {{ item.content === '.' ? 'غیرفعال' : 'فعال' }}
            </b-form-checkbox>
            <b-badge v-if="item.content === '.'" variant="secondary" class="mr-1">
              در سایت نمایش داده نمی‌شود
            </b-badge>
          </div>

          <b-form-group
              :label="item.title"
              :label-for="`contact-content-${item.staticPageId || item.title}`"
              class="mb-2"
          >
            <b-form-textarea
                :id="`contact-content-${item.staticPageId || item.title}`"
                rows="4"
                v-model="item.content"
                :disabled="item.content === '.'"
            ></b-form-textarea>
          </b-form-group>

          <!-- Action Buttons -->
          <b-button
              variant="primary"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="updateSection(item)"
          >
            ثبت
          </b-button>

        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { BCard, BRow, BCol, BButton, BOverlay, BFormTextarea, BFormGroup, BFormCheckbox, BBadge } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { StaticPageGetByTypeRequest, StaticPageUpdateRequest, StaticPageCreateRequest } from '@/libs/Api/StaticPage'

const contactFields = [
  ['شماره تماس 1', 'شماره تماس ۱'], ['شماره تماس 2', 'شماره تماس ۲'], ['ایمیل'],
  ['لینک آدرس اینستاگرام'], ['لینک آدرس یوتیوب'],
  ['لینک آدرس تلگرام', 'لینک اپلیکیشن تلگرام'],
  ['لینک اپلیکیشن ایتا'], ['لینک اپلیکیشن بله'],
  ['آدرس'], ['ساعات پاسخگویی'],
]

export default {
  name: 'contactUs',
  title: 'ویرایش تماس با ما - پنل ادمین بنفشه باقری',
  components: { BCard, BRow, BCol, BButton, BOverlay, BFormTextarea, BFormGroup, BFormCheckbox, BBadge },
  data() { return { pageData: [], showLoading: false } },
  async created() { await this.getData() },
  methods: {
    setActive(item, active) {
      item.content = active ? '' : '.'
    },
    async getData() {
      this.showLoading = true
      try {
        const request = new StaticPageGetByTypeRequest(this)
        request.setType(1)
        await request.fetch(content => {
          const items = Array.isArray(content) ? content : (content && Array.isArray(content.data) ? content.data : [])
          this.pageData = items.slice()
          contactFields.forEach(titles => {
            if (!items.some(item => titles.includes(String(item.title || '').trim()))) {
              this.pageData.push({ title: titles[0], content: '', type: 1, state: 1 })
            }
          })
        }, () => {})
      } finally {
        this.showLoading = false
      }
    },
    async updateSection(item) {
      this.showLoading = true
      try {
        const request = item.staticPageId
          ? new StaticPageUpdateRequest(this)
          : new StaticPageCreateRequest(this)
        request.setParams({ ...item, content: String(item.content == null ? '' : item.content) })
        let saved = false
        await request.fetch(() => { saved = true }, () => {})
        if (saved) {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'اطلاعات تماس ذخیره شد.' },
          })
          await this.getData()
        }
      } finally {
        this.showLoading = false
      }
    },
  },
}
</script>

<style scoped>
.contact-item-inactive {
  border: 1px solid #ced4da;
  background: #f8f9fa;
  opacity: .8;
}
</style>
